<template>
  <div
    class="navigation-button"
    id="js-navigation-button"
    v-on:click="open = !open"
  >
    <div class="navigation-button-inner">
      <span class="navigation-button-mark navigation-button-mark-top"></span>
      <span class="navigation-button-mark navigation-button-mark-middle"></span>
      <span class="navigation-button-mark navigation-button-mark-bottom"></span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import jQuery from "jquery";
const $ = jQuery;

export default Vue.extend({
  data: function () {
    return {
      open: false,
      position: 0,
      scrollStop: false,
    };
  },
  watch: {
    open: function (val) {
      if (val) {
        this.stopScroll();
        $("#js-wrapper").css({ top: -this.position });
        $("#js-navigation-button").addClass("is-open");
        $("#js-navigation-header").addClass("is-open");
        $("#js-wrapper").addClass("is-freeze");
        this.setScroll();
      } else {
        this.startScroll();
        $("#js-navigation-sp-mask").removeClass("is-fixed");
        $("#js-navigation-button").removeClass("is-open");
        $("#js-navigation-header")
          .removeClass("is-scroll")
          .removeClass("is-open");
        $("#js-wrapper").removeClass("is-freeze").css({ top: "" });
        $(document).scrollTop(this.position);
      }
    },
  },
  methods: {
    stopScroll: function () {
      this.scrollStop = true;
    },
    startScroll: function () {
      this.scrollStop = false;
    },
    setScroll: function () {
      if ($("#js-navigation-header").hasClass("is-open")) {
        $("#js-navigation-header").addClass("is-scroll");
        $("#js-navigation-sp-mask").addClass("is-fixed");
      }
    },
  },
});
</script>
